var Unit = /** @class */ (function () {
    function Unit() {
    }
    Unit.isUnit = function (x) {
        return !!x && typeof x.id === 'number' && typeof x.label === 'string' && typeof x.partition_type === 'string';
    };
    return Unit;
}());
export { Unit };
export var PartitionType;
(function (PartitionType) {
    PartitionType.current = 'current';
    PartitionType.includeLower = 'includeLower';
})(PartitionType || (PartitionType = {}));
//# sourceMappingURL=unit.js.map